import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const calendarDurationCol = (gantt, t) => ({
  name: 'calendarDuration',
  label: 'Duración Días Calendario',
  align: 'center',
  resize: true,
  width: 100,
  template: (activity) => {
    const { id, type, start_date: start, end_date: end } = activity;
    const hasChild = gantt.hasChild(id);
    const { calendarDuration: isOdd } = gantt.oddColsConfig;
    const classPrefix = isOdd ? '' : 'non-';

    const classes = `class="${classPrefix}odd-col"`;
    const styles = hasChild && 'style="font-weight: 600"';

    const cellContent = (days) =>
      `<div ${classes} ${styles}>${days} ${t('tables.gantt.day')}${days === 1 ? '' : 's'}</div>`;

    if (type === 'milestone') {
      activity.calendarDuration = 0;
      return cellContent(0);
    }

    if (Number.isNaN(start) || Number.isNaN(end)) {
      activity.calendarDuration = null;
      return `<div ${classes}></div>`;
    }

    const dayInMs = 1000 * 60 * 60 * 24;
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startInMs = startDate.getTime();
    const endInMs = endDate.getTime();

    const durationInDays = Math.floor((endInMs - startInMs) / dayInMs) + 1;
    activity.calendarDuration = durationInDays;
    return cellContent(durationInDays);
  },
  hide: !isColumnVisibleByDefault('calendarDuration'),
  data_type: 'number',
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → 9', '9 → 1'],
  filterable: true
});

export default calendarDurationCol; 